<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['展商邀约观众信息']"/>
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="4">
            <span class="search-text">展商名称：</span>
            <el-input
                class="search-item"
                placeholder="请输入"
                v-model="companyName"
                size="small"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <span class="search-text">公司名称：</span>
            <el-input
                class="search-item"
                placeholder="请输入"
                v-model="company"
                size="small"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <span class="search-text">姓名：</span>
            <el-input
                class="search-item"
                placeholder="请输入"
                v-model="fullName"
                size="small"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <span class="search-text">手机号：</span>
            <el-input
                class="search-item"
                placeholder="请输入"
                v-model="phoneNumber"
                size="small"
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-button @click="search" class="btn-search" round icon="el-icon-search" size="small">查询</el-button>
            <el-button @click="reset" type="warning" round icon="el-icon-refresh" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row class="common-margin flex-1 table-main">
          <el-table
              :data="tableData"
              class="flex-1" stripe height="100%"
              style="width: 100%"
              border
          >
            <el-table-column label="序号" type="index" width="60px" fixed align="center"></el-table-column>
            <el-table-column label="姓名" prop="fullName" align="center"></el-table-column>
            <el-table-column label="手机号" prop="phoneNumber" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="邮箱" prop="email" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="公司名称" prop="company" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="职务" prop="jobTitle" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="部门" prop="department" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="展会届数" prop="sessions" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="邀约时间" prop="createTime" align="center" show-overflow-tooltip width="160">
            </el-table-column>
          </el-table>
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes"
              :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader'

export default {
  data () {
    return {
      companyName: '',
      company: '',
      fullName: '',
      phoneNumber: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  components: {
    navHeader
  },
  created () {
    this.getPageList()
  },
  methods: {
    async getPageList () {
      let params = {
        companyName: this.companyName,
        company: this.company,
        fullName: this.fullName,
        phoneNumber: this.phoneNumber,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      let {data: res} = await this.$http.post(
        '/visitUser/getPageList',
        params
      )
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = parseInt(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    reset () {
      this.companyName = ''
      this.company = ''
      this.fullName = ''
      this.phoneNumber = ''
      this.pageSize = 10
      this.currentPage = 1
      this.getPageList()
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/fissionInfo/index.vue